var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 -2 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 9.66 17.96 9.33 17.92 9H17.9381C17.574 6.07992 15.6361 3.64858 13 2.58152V3C13 4.1 12.1 5 11 5H9V7C9 7.55 8.55 8 8 8H6V10H12C12.55 10 13 10.45 13 11V14H14C14.9 14 15.64 14.58 15.9 15.39C17.2 13.97 18 12.08 18 10ZM2.99132 13.8603C4.20012 16.0487 6.40599 17.6082 9 17.93V16C7.9 16 7 15.1 7 14V13L2.21 8.21C2.08 8.79 2 9.38 2 10C2 11.3999 2.35954 12.7157 2.99132 13.8603ZM11.4825 0.109129C16.3023 0.825396 20 4.98088 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C10.5058 0 10.9999 0.0371214 11.4825 0.109129Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEarth);
export default __webpack_public_path__ + "static/media/icon_earth.057713f204bd58ca585cc2d43eeaafaf.svg";
export { ForwardRef as ReactComponent };